"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGiftcloudRewardEventNotification = exports.ZGiftcloudRewardEvent = void 0;
const zod_1 = require("zod");
exports.ZGiftcloudRewardEvent = zod_1.z.object({
    EventId: zod_1.z.string(),
    EventType: zod_1.z.string(),
    EventTime: zod_1.z.string(),
    EmailType: zod_1.z.string().optional(),
    SmsType: zod_1.z.string().optional(),
    ClientReference: zod_1.z.string(),
    GiftName: zod_1.z.string().optional(),
    RecipientEmailAddress: zod_1.z.string().optional(),
    RecipientPhoneNumber: zod_1.z.string().optional(),
});
exports.ZGiftcloudRewardEventNotification = zod_1.z.object({
    Events: exports.ZGiftcloudRewardEvent.array(),
});
//# sourceMappingURL=models.js.map